import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

import getCustomerInvoiceListByStatusCode from 'src/customer-invoice/use-cases/getCustomerInvoiceListByStatusCode';
import { formatNumber } from 'src/shared/support/number';

const useStyles = makeStyles((theme) => ({
  table: {
    width: 400
  },
  green: {
    background: 'green',
    color: 'white'
  },
  red: {
    background: 'red',
    color: 'white'
  },
  yellow: {
    background: 'yellow',
    color: 'black'
  }
}));

const CustomerAccountSummaryStatus = ({
  customerId,
  customerPaymentReceiptList
}) => {
  const classes = useStyles();
  const [status, setStatus] = useState({});

  const getCustomerAccountStatus = async () => {
    let accountStatus = {};

    const customerPendingInvoiceList = await getCustomerInvoiceListByStatusCode(
      {
        customerId,
        statusCode: 'PENDING_PAYMENT,PARTIAL_PAYMENT',
        page: null,
        orderBy: ''
      }
    );

    if (customerPendingInvoiceList && customerPendingInvoiceList.count) {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;

      const pendingAmount = formatNumber(
        customerPendingInvoiceList.rows.map((x) => x.rest).reduce(reducer)
      );

      accountStatus = {
        text: 'DEUDA',
        className: classes.red,
        number: customerPendingInvoiceList.count,
        pendingAmount
      };
    } else {
      accountStatus = {
        text: 'AL DÍA',
        className: classes.green,
        number: 0,
        pendingAmount: 0
      };
    }

    setStatus(accountStatus);
  };

  useEffect(() => {
    getCustomerAccountStatus();
  }, []);

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableBody>
          <TableRow key={'status'}>
            <TableCell component="th" scope="row">
              Estado
            </TableCell>
            <TableCell align="right" className={status.className}>
              {status.text}
            </TableCell>
          </TableRow>
          <TableRow key={'numberPendingInvoices'}>
            <TableCell component="th" scope="row">
              Nº de facturas pendientes
            </TableCell>
            <TableCell align="right">{status.number}</TableCell>
          </TableRow>
          <TableRow key={'pendingAmount'}>
            <TableCell component="th" scope="row">
              Monto pendiente
            </TableCell>
            <TableCell align="right">{status.pendingAmount} Gs.</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomerAccountSummaryStatus;
